import { connect } from 'react-redux';
import { SetPassword as Component } from './component';
import { checkPassword, disablePassword } from '../actions/user';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
    isPasswordSet: state.isPasswordSet,
    shouldPasswordBeSet: state.shouldPasswordBeSet,
    initial: state.user && state.user.initial
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      checkPassword,
      disablePassword
    },
    dispatch
  );
};

const Container: React.ComponentClass<any> = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;



// WEBPACK FOOTER //
// ./src/set-password/container.ts